/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type VoiceAiScreenerCallbackSchedulingDto = {
    start: string;
    end: string;
    timeZone: string;
    source: VoiceAiScreenerCallbackSchedulingDto.source;
}

export namespace VoiceAiScreenerCallbackSchedulingDto {

    export enum source {
        PATIENT = 'patient',
        FALLBACK = 'fallback',
    }


}
